import { SxProps, Theme } from '@mui/material';

type TStyles = {
  radioBtn: SxProps<Theme>;
  container: SxProps<Theme>;
  infoIcon: SxProps<Theme>;
  radioFormControl: SxProps<Theme>;
  disabledCheckbox: SxProps<Theme>;
  textContainer: SxProps<Theme>;
  iconButton: SxProps<Theme>;
  label: SxProps<Theme>;
  informer: SxProps<Theme>;
};

export const styles: TStyles = {
  radioBtn: (theme: Theme) => ({
    alignItems: 'center',
    '& .MuiRadio-root': { padding: 0 },
    '& .MuiFormControlLabel-label': { padding: 0 },
    '& .MuiSvgIcon-root': { width: theme.spacing(2.3) },
  }),
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    position: 'relative',
    width: '100%',
  },

  infoIcon: (theme: Theme) => ({
    color: `${theme.palette.primary.main}70`,
    '&:hover': { color: theme.palette.primary.main },
  }),
  radioFormControl: {
    alignItems: 'center',
    '.MuiFormControlLabel-label': { padding: 0 },
    gap: 0,
  },
  disabledCheckbox: (theme: Theme) => ({
    '&.Mui-disabled': {
      color: theme.palette.grey.additionalGrey,
      opacity: 0.7,
      cursor: 'not-allowed',
      pointerEvents: 'auto',
    },
  }),

  textContainer: {
    zIndex: 1,
    pointerEvents: 'auto',
    marginLeft: 'auto',
    position: 'relative',
    right: 0,
  },

  iconButton: {
    paddingRight: '12px',
    zIndex: 2,
    position: 'relative',
    '&:hover': { backgroundColor: 'transparent' },
    '&:active': { backgroundColor: 'transparent' },
  },
  label: (theme: Theme) => ({
    fontSize: '12px',
    color: theme.palette.text.primary,
    '&.Mui-focused': {
      color: theme.palette.text.primary,
    },
  }),
  informer: () => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
  }),
};
